"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHtmlTag = function (elementName, attrs) {
    return Object.keys(attrs)
        .reduce(function (result, attrName) { return result + " " + attrName + "=\"" + attrs[attrName] + "\""; }, "<" + elementName)
        .concat(' />');
};
